import { Navigate } from "react-router-dom";
import { useEffectiveRole } from "@/hooks/useEffectiveRole";

export default function PostLogin() {
  const { role: effectiveRole, loading } = useEffectiveRole();

  console.log("[PostLogin] role:", effectiveRole, "loading:", loading);

  // CRITICAL: Never make routing decisions while loading
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-muted-foreground">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  // Redirect based on role
  if (effectiveRole === "admin") {
    return <Navigate to="/admin" replace />;
  }
  if (effectiveRole === "portfolio_manager") {
    return <Navigate to="/pm" replace />;
  }
  if (effectiveRole === "client_admin") {
    return <Navigate to="/client/sub-orgs" replace />;
  }
  if (effectiveRole === "org_admin") {
    return <Navigate to="/org-admin" replace />;
  }
  if (effectiveRole === "master_reviewer" || effectiveRole === "reviewer") {
    return <Navigate to="/reviewer" replace />;
  }
  if (effectiveRole === "respondent") {
    return <Navigate to="/dashboard" replace />;
  }

  // No recognized role — do NOT redirect to /login (causes loop).
  // Show a static error screen instead.
  console.warn("[PostLogin] No role resolved after loading. Showing no-role screen.");
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center max-w-md mx-auto p-6">
        <div className="text-amber-500 text-5xl mb-4">⚠️</div>
        <h2 className="text-2xl font-bold mb-2">No Role Assigned</h2>
        <p className="text-muted-foreground mb-4">
          Your account does not have a role assigned. Please contact your administrator.
        </p>
        <button
          onClick={() => {
            import("@/integrations/supabase/client").then(({ supabase }) => {
              supabase.auth.signOut().then(() => {
                window.location.href = "/login";
              });
            });
          }}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
